import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import customConfig from 'src/config';
import { IS_UAE } from '@Utils/const';
import localesHash from '../locales-hash?raw';

const i18nextOptions = {
  // order and from where user language should be detected
  order: ['localStorage', 'navigator'],

  // keys or params to lookup language from
  lookupLocalStorage: 'i18nextLng',
};

const lang = ['en', 'ja', 'it', 'de', 'pt', 'es'];
const isInUIC =
  localStorage.getItem('uic_companyGUID') !== null ||
  localStorage.getItem('uic-token') !== null;
/**
 * https://www.i18next.com/overview/configuration-options
 */
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use({
    name: 'replaceProductName',
    type: 'postProcessor',
    process(value: string, key: string) {
      if (
        key &&
        key[0] &&
        key[0] === 'provision.service.gmail.error.FAILURE;781'
      ) {
        return value;
      }

      if (isInUIC) {
        if (
          (key && key[0] && key[0].startsWith('welcome.')) ||
          ['header.banner.modal.how.p6'].includes(key[0])
        ) {
          return value;
        }
        return value
          .replace(
            /Trend Micro Cloud App Security/g,
            'Trend Vision One Cloud Email and Collaboration Protection'
          )
          .replace(
            /Cloud App Security/g,
            'Cloud Email and Collaboration Protection'
          );
      } else if (IS_UAE) {
        if (
          key &&
          key[0] &&
          key[0] === 'policy.WebReputation.ApprovedUrlList.note'
        ) {
          return value;
        }
        return value
          .replace(/Trend Micro/g, 'Cyber Eye')
          .replace(/Cloud App Security/g, 'Cloud Service Security');
      }
      return value;
    },
  })
  .init(
    {
      postProcess: ['replaceProductName'],
      compatibilityJSON: 'v3',
      detection: i18nextOptions,
      backend: {
        loadPath: `${
          customConfig.ui.prefix === '/ui/cas' ? '/static/cas' : ''
        }/locales/{{lng}}/{{ns}}.json`,
        queryStringParams: { hash: localesHash },
      },
      debug: customConfig.ui['3rdParties'].i18nextDebug,
      fallbackLng: 'en',
      load: 'all',
      ns: [
        'common',
        'dashboard',
        'header',
        'side',
        'log',
        'notification',
        'task',
        'timeZone',
        'errors',
        'reportCommon',
        'apt',
        'recommendConfig',
        'quarantine',
        'administration',
        'policy',
        'dlp',
        'policy',
        'riskUser',
        'globalSetting',
        'serviceAccount',
        'provision',
        'operations',
        'welcome',
        'login',
        'riskAi',
      ],
      fallbackNS: [
        'common',
        'dashboard',
        'header',
        'side',
        'log',
        'notification',
        'task',
        'timeZone',
        'errors',
        'reportCommon',
        'apt',
        'recommendConfig',
        'quarantine',
        'administration',
        'policy',
        'dlp',
        'policy',
        'riskUser',
        'globalSetting',
        'serviceAccount',
        'welcome',
        'login',
        'riskAi',
        'operations',
      ],
      interpolation: {
        escapeValue: false,
      },
      // parseMissingKeyHandler: (key) => key,
      // i18n.language === 'en' ? key : i18n.t(key, { lng: 'en' }),
    },
    (err) => {
      if (err) {
        console.warn('something went wrong loading', err);
        let tempLang = 'en';
        if (isInUIC) {
          tempLang = localStorage.getItem('uic_language') || 'en';
        }
        const find = lang.filter((item) => i18n.language.indexOf(item) === 0);
        if (find.length !== 0) {
          tempLang = find[0];
        }
        i18n.changeLanguage(tempLang).then();
        localStorage.setItem('i18nextLng', tempLang);
      }
    } // -> same as i18next.t})
  );

export default i18n;
